import { PathUtils } from 'slate';

function getPreviousPath(path) {
  var newPath = PathUtils.decrement(path);

  while (newPath.last() < 0 && !newPath.isEmpty()) {
    newPath = PathUtils.decrement(PathUtils.lift(newPath));
  }

  return newPath.isEmpty() ? null : newPath;
}

export default function getPreviousNodesFromPath(parent, startPath) {
  var nodes = [];
  var path = getPreviousPath(startPath);
  var node = parent.getNode(path);

  while (node) {
    nodes.push(node);
    path = getPreviousPath(path);
    node = parent.getNode(path);
  }

  return nodes.reverse();
}